import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NavigationEnd, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-layout-post',
  templateUrl: './layout-post.component.html',
  styleUrls: ['./layout-post.component.scss']
})
export class LayoutPostComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;

  @ViewChild("mobile") mobileView: SidebarComponent
  @ViewChild("desktop") desktopView: SidebarComponent
  @ViewChild("drawer") drawer: MatSidenav;
  mode = new UntypedFormControl('push');
  public company_name;
  public company_uuid;
  public company_slogan = '';
  get shareholder(): boolean { return this.http.isUnityShareholder || this.http.isViewingUser; }
  get viewAs(): any { return this.http.viewAs; }
  exitViewAs() { return this.http.exitViewAs(); }
  public fullwidth = false;
  public companies: any = [];
  public wallet_balance;
  public ai_balance;
  public showColorPicker = false;
  public themeColors = [
    { name: 'Blue',      color: '0,123,255',   text: '#fff' },
    { name: 'Indigo',    color: '99,102,241',   text: '#fff' },
    { name: 'Purple',    color: '139,92,246',   text: '#fff' },
    { name: 'Pink',      color: '236,72,153',   text: '#fff' },
    { name: 'Red',       color: '239,68,68',    text: '#fff' },
    { name: 'Orange',    color: '249,115,22',   text: '#fff' },
    { name: 'Yellow',    color: '255,211,0',    text: '#000' },
    { name: 'Green',     color: '34,197,94',    text: '#fff' },
    { name: 'Teal',      color: '20,184,166',   text: '#fff' },
    { name: 'Cyan',      color: '6,182,212',    text: '#fff' },
    { name: 'Slate',     color: '71,85,105',    text: '#fff' },
    { name: 'Dark',      color: '30,41,59',     text: '#fff' },
  ];
  public activeColor = '0,123,255';
  public showLangPicker = false;
  public languages = [
    { code: 'en', label: 'English',  flag: '🇬🇧' },
    { code: 'ms', label: 'Malay',    flag: '🇲🇾' },
    { code: 'cn', label: '中文',      flag: '🇨🇳' },
  ];
  public activeLang = 'en';
  @ViewChild('customNotification', { static: true }) customNotificationTmpl;
  @ViewChild('customNotificationDeposit', { static: true }) customNotificationDepositTmpl;
  @ViewChild('customNotificationWithdraw', { static: true }) customNotificationWithdrawTmpl;
  public pendingDepositCount: number = 0;
  public pendingWithdrawCount: number = 0;
  public showPendingModal: boolean = false;
  public marqueeText: string = '';
  public safeMarqueeHtml: SafeHtml = '';

  // Live Chat floating offcanvas
  public chatUnread: number = 0;
  private chatOffcanvasRef: NgbOffcanvasRef | null = null;
  get chatOpen(): boolean { return !!this.chatOffcanvasRef; }

  private _mobileQueryListener: () => void;
  private companySubscription: Subscription;

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.companySubscription?.unsubscribe();
  }

  constructor(private http: HttpService, private router: Router, private elementRef: ElementRef, private renderer: Renderer2, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private sanitizer: DomSanitizer, private offcanvas: NgbOffcanvas) {

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.fullwidth = this.router.url.indexOf("whatsapp") > -1;

        // Auto-close drawer on mobile after navigation
        if (this.mobileQuery.matches && this.drawer) {
          this.drawer.close();
        }
      }
    })

    this.http.getSelectedCompany().subscribe(async (v) => {
      const company = this.http.getSelecetdCompanyDetail();
      this.company_name = company && company['name'] ? company['name'] : ''
      this.company_uuid = v;
      this.getWalletBalance();
      this.getAiBalance();
      this.loadSlogan();
      this.getPendingCounts();
    });

    this.http.getNewMessage().subscribe((message: any) => {
      if (message && message.user_type == "user") {
        this.http.toast(message.message, "success", this.customNotificationTmpl, message.room);
        // Badge on the floating chat button — only while the panel is closed
        if (!this.chatOpen) {
          this.chatUnread++;
        }
      }
    });

    this.http.getNewDeposit().subscribe((message: any) => {
      if (message) {
        this.http.toast(message.message, "success", this.customNotificationDepositTmpl);
        this.getPendingCounts();
      }
    });

    this.http.getNewWithdraw().subscribe((message: any) => {
      if (message) {
        this.http.toast(message.message, "success", this.customNotificationWithdrawTmpl);
        this.getPendingCounts();
      }
    });
  }

  async loadMarquee() {
    if (this.shareholder) return;
    try {
      const res: any = await this.http.post('/admin/marquee');
      const raw = res?.text || '';
      const stripped = raw.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
      this.marqueeText = stripped ? raw : '';
      if (this.marqueeText) {
        this.safeMarqueeHtml = this.sanitizer.bypassSecurityTrustHtml(this.marqueeText);
      }
    } catch (_) {}
  }

  ngOnInit(): void {
    this.companySubscription = this.http.getCompanyChanges().subscribe(companies => {
      this.companies = companies;
      const selected = companies.find(c => c.uuid === this.company_uuid);
      this.company_name = selected?.name || '';
    });
    this.loadMarquee();
    const savedColor = localStorage.getItem('--theme-color');
    const savedText = localStorage.getItem('--theme-text');
    if (savedColor) {
      this.activeColor = savedColor;
      document.documentElement.style.setProperty('--color', savedColor);
      document.documentElement.style.setProperty('--text', savedText || '#fff');
    }
    this.getCompany();

    const savedLang = localStorage.getItem('--panel-lang');
    if (savedLang) {
      this.activeLang = savedLang;
    }
  }

  async getPendingCounts() {
    if (this.shareholder) return;
    try {
      const d: any = await this.http.post('/admin/deposit/count');
      this.pendingDepositCount = d?.count ?? 0;
    } catch (e) { this.pendingDepositCount = 0; }
    try {
      const w: any = await this.http.post('/admin/withdraw/count');
      this.pendingWithdrawCount = w?.count ?? 0;
    } catch (e) { this.pendingWithdrawCount = 0; }
    this.showPendingModal = this.pendingDepositCount > 0 || this.pendingWithdrawCount > 0;
  }

  async getWalletBalance() {
    if (this.shareholder) return;
    let y: any = await this.http.post("/admin/wallet/balance");
    this.wallet_balance = y.balance;
  }

  async getAiBalance() {
    if (this.shareholder) return;
    try {
      let y: any = await this.http.post("/admin/ai/wallet/balance");
      this.ai_balance = y.balance;
    } catch (e) {
      this.ai_balance = 0;
    }
  }

  async logout() {
    if (this.http.isViewingUser) return this.http.exitViewAs();
    const access = this.http.getAccess();
    await this.http.post("/admin/logout", { token: access.token })
    this.http.closeAllWindow();
    this.http.clearAccess();
    this.http.navigate(['/lr'])
  }

  async getCompany() {
    this.companies = await this.http.getCompany();
  }

  async loadSlogan() {
    if (this.shareholder) return;
    try {
      const rtn: any = await this.http.post('/admin/company/setting');
      this.company_slogan = rtn.setting?.slogan || '';
    } catch (e) {
      this.company_slogan = '';
    }
  }

  openChatPanel(content: any) {
    if (this.chatOffcanvasRef) {
      return; // already open
    }
    this.chatUnread = 0;
    this.chatOffcanvasRef = this.offcanvas.open(content, {
      position: 'end',
      panelClass: 'chat-offcanvas-panel',
      backdropClass: 'chat-offcanvas-backdrop',
      scroll: true,
    });
    const clear = () => { this.chatOffcanvasRef = null; };
    this.chatOffcanvasRef.result.then(clear, clear);
  }

  toggleColorPicker() {
    this.showColorPicker = !this.showColorPicker;
    this.showLangPicker = false;
  }

  toggleLangPicker() {
    this.showLangPicker = !this.showLangPicker;
    this.showColorPicker = false;
  }

  applyLang(lang: { code: string }) {
    this.activeLang = lang.code;
    localStorage.setItem('--panel-lang', lang.code);
    window.dispatchEvent(new CustomEvent('panel-lang-change', { detail: lang.code }));
    this.showLangPicker = false;
  }

  applyColor(theme: { color: string, text: string }) {
    this.activeColor = theme.color;
    document.documentElement.style.setProperty('--color', theme.color);
    document.documentElement.style.setProperty('--text', theme.text);
    localStorage.setItem('--theme-color', theme.color);
    localStorage.setItem('--theme-text', theme.text);
    this.showColorPicker = false;
  }

}
